// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__zAahs","loader":"Loader_loader__qKRha","shadowRolling":"Loader_shadowRolling__Ybhgy"};